<script setup>
/*
    Line widget

    Components:
        primary: <v-sheet>

    Widget Properties:
        value: []

    CSS Properties:
        border-top-style: none, hidden, dotted, dashed, solid, double, groove, ridge, inset, outset
        border-top-width
        border-top-color
        transform: rotate(45deg)
    
    Examples:
        transform: rotate(45deg)
 */
import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({update})

const props = defineProps({
    loading: Boolean,
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
})

const primary = ref(null)

const DefaultStyles = {
    card: {
        background: 'transparent',
    },
    primary: {
        'border-top-color': 'rgb(var(--v-theme-text))',
        'border-top-style': 'solid',
        'border-top-width': '4px',
        'background': 'transparent',
        'transform-origin': 'left top',
    },
}

function update() {
    Object.assign(page, getWidgetProps(props.widget, {primary}, {styles: DefaultStyles}))
}
</script>

<template>
    <v-sheet ref="primary" class="line-widget" v-bind="page.args" />
</template>

<style lang="scss" scoped>
.line-widget {
    container-type: size;
    position: relative;
    height: 100cqh !important;
    width: 100cqw !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.arrowhead {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 10px solid black;
}
</style>
